/* „Twoje tagi" over the table — the tag boards' `F2-lista` `.chipbar` and `.qchip`, 10 October 2026.
 *
 * One line under the scope switch, a hairline under it like the switch's own. Every text leaf
 * states its line-height. The counts are `--text-2` rather than the board's `--text-3`, which
 * measures 3.01:1 in Flame — the same call as deviations register entry 18 made for every count on
 * this screen. */

.bar {
  display: flex;
  flex: none;
  gap: var(--space-6px);
  align-items: center;
  min-inline-size: var(--space-0);
  padding: var(--space-9px) var(--space-13px);
  border-bottom: var(--border-hairline) solid var(--border);
}

.glyph {
  flex: none;
  width: 14px;
  height: 14px;
  color: var(--text-2);
}

.label {
  flex: none;
  margin-right: var(--space-1);
  font-size: var(--fs-label-sm);
  font-weight: var(--fw-bold);
  line-height: var(--lh-auto);
  letter-spacing: var(--ls-group);
  color: var(--text-2);
  text-transform: uppercase;
  white-space: nowrap;
}

/* The chips' own scroller, so two hundred tags scroll sideways rather than clip. The 2px of block
 * padding keeps a focused chip's ring inside the scrollport. */
.chips {
  --sb-size: 4px;

  display: flex;
  flex: 1;
  gap: var(--space-6px);
  align-items: center;
  min-inline-size: var(--space-0);
  padding: var(--space-2px);
  overflow-x: auto;
  overscroll-behavior-x: contain;
}

.chip {
  display: inline-flex;
  flex: none;
  gap: var(--space-5px);
  align-items: center;
  height: 24px;
  padding: var(--space-0) var(--space-10px);
  font-size: var(--fs-caption);
  font-weight: var(--fw-bold);
  line-height: var(--lh-auto);
  color: var(--text-2);
  white-space: nowrap;
  background: transparent;
  border: var(--border-hairline) solid var(--border-2);
  border-radius: var(--r-pill);
  cursor: pointer;
}

.chip:hover {
  color: var(--text);
}

.chip:focus-visible {
  outline: var(--border-focus) solid var(--focus);
  outline-offset: var(--space-2px);
}

.chipOn,
.chipOn:hover {
  color: var(--on-ink);
  background: var(--text);
  border-color: var(--text);
}

.count {
  font-size: var(--fs-micro-label);
  font-style: normal;
  font-weight: var(--fw-extrabold);
  line-height: var(--lh-auto);
  color: var(--text-2);
  font-variant-numeric: tabular-nums;
}

.chipOn .count {
  color: var(--on-ink-soft);
}

/* „Zarządzaj" is the canon's one ink word on the line: it opens something rather than undoing.
 * Under `.bar`, because `shared/ui/filterPanel`'s `.clear` sets the same property at the same
 * specificity and two modules are settled by chunk order, which differs between dev and build. */
.bar .manage {
  color: var(--text);
}
